module.exports = __webpack_public_path__ + "img/webcamera-icon-white.54c46986.svg";